import ServicePanel from './ServicePanel';

export default ServicePanel;
